import type {WidgetLogic} from "../logic-export.types";

const deprecatedStandinWidgetLogic: WidgetLogic = {
    name: "deprecated-standin",
    accessible: true,
};

export default deprecatedStandinWidgetLogic;
